import { noEnvRoutes } from "@/assets/routes/routes";
import api from "../api";
import { isAxiosError } from "axios";

export const getImages = async ({ images }: { images: string[] }) => {
  try {
    const urls: string[] = [];

    for (let index = 0; index < images.length; index += 1) {
      urls.push(`filename=${images[index]}`);
    }

    const url = `${noEnvRoutes.getImage}?${urls.join("&")}`;
    const { data } = await api.get(url);

    return data.map((image: { url: string }) => image.url);
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      throw new Error(error.response.data.message);
    } else {
      throw new Error("Ha habido un problema");
    }
  }
};
